var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          class: _vm.MODAL_ID,
          attrs: {
            id: _vm.MODAL_ID,
            title: "Extract Claims",
            size: "lg",
            centered: "",
            scrollable: "",
            "hide-footer": "",
          },
          on: { hide: _vm.close },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("\n        Close\n      ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "b-tabs",
            {
              attrs: { "content-class": "mt-3" },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("b-tab", { attrs: { title: "Extract", active: "" } }, [
                _c(
                  "div",
                  { staticClass: "extract-tab" },
                  [
                    _c(
                      "div",
                      { staticClass: "prompt-section mb-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "prompt-header d-flex justify-content-between align-items-center p-2 bg-light rounded cursor-pointer",
                            on: {
                              click: function ($event) {
                                _vm.promptExpanded = !_vm.promptExpanded
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _c("i", {
                                class: _vm.promptExpanded
                                  ? "bi bi-chevron-down"
                                  : "bi bi-chevron-right",
                              }),
                              _vm._v(
                                "\n                AI Prompt Configuration\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.promptExpanded
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant: "outline-secondary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.resetPrompt.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Reset to Default\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          {
                            staticClass: "mt-2",
                            model: {
                              value: _vm.promptExpanded,
                              callback: function ($$v) {
                                _vm.promptExpanded = $$v
                              },
                              expression: "promptExpanded",
                            },
                          },
                          [
                            _c("b-form-textarea", {
                              staticClass: "mb-2",
                              attrs: {
                                rows: "8",
                                "max-rows": "12",
                                placeholder:
                                  "Enter custom prompt for AI extraction...",
                              },
                              model: {
                                value: _vm.customPrompt,
                                callback: function ($$v) {
                                  _vm.customPrompt = $$v
                                },
                                expression: "customPrompt",
                              },
                            }),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                "\n                Customize the prompt to change how the AI extracts and formats the text.\n              "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          label:
                            "Upload a PDF, JPG or PNG file to extract the claims text.",
                        },
                      },
                      [
                        _c("Vue2Dropzone", {
                          ref: "fileInput",
                          attrs: {
                            id: "excelDropzone",
                            options: _vm.dropzoneOptions,
                          },
                          on: {
                            "vdropzone-file-added": _vm.setFile,
                            "vdropzone-removed-file": _vm.removeFile,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { id: "open_file_browser_btn", type: "button" },
                      },
                      [
                        _c("i", { staticClass: "bi bi-folder2-open" }),
                        _vm._v(" File Browser\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-end mb-3" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              disabled: !_vm.selectedFile || _vm.isExtracting,
                            },
                            on: { click: _vm.extractClaims },
                          },
                          [
                            _vm.isExtracting
                              ? _c("b-spinner", {
                                  staticClass: "mr-1",
                                  attrs: { small: "" },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n              Extract claims\n            "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isExtracting
                      ? _c(
                          "div",
                          { staticClass: "text-center my-4" },
                          [
                            _c("b-spinner", {
                              staticStyle: { width: "3rem", height: "3rem" },
                              attrs: { variant: "primary" },
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-2 text-muted" }, [
                              _vm._v(
                                "\n              Extracting text from file...\n            "
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.extractedText
                      ? _c("div", { staticClass: "extracted-results mt-4" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center mb-2",
                            },
                            [
                              _c("h6", [_vm._v("Extracted Text:")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        variant: "outline-primary",
                                        size: "sm",
                                      },
                                      on: { click: _vm.copyAllText },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "bi bi-clipboard",
                                      }),
                                      _vm._v(" Copy All\n                "),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-success",
                                        text: "Download",
                                        right: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-dropdown-item",
                                        { on: { click: _vm.downloadAsText } },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-file-earmark-text",
                                          }),
                                          _vm._v(
                                            " Download as TXT\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "extracted-text-container p-3 border rounded",
                            },
                            [
                              _c("pre", { staticClass: "mb-0" }, [
                                _vm._v(_vm._s(_vm.extractedText)),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("b-tab", { attrs: { title: "History" } }, [
                _c("div", { staticClass: "history-tab" }, [
                  _vm.isLoadingHistory
                    ? _c(
                        "div",
                        { staticClass: "text-center py-5" },
                        [
                          _c("b-spinner", { attrs: { variant: "primary" } }),
                          _vm._v(" "),
                          _c("p", { staticClass: "mt-2 text-muted" }, [
                            _vm._v(
                              "\n              Loading history...\n            "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm.history.length === 0
                    ? _c(
                        "div",
                        { staticClass: "text-center text-muted py-5" },
                        [_c("p", [_vm._v("No extraction history yet.")])]
                      )
                    : _vm.selectedHistory
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center mb-3",
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatDate(_vm.selectedHistory.created_at)
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      size: "sm",
                                      variant: "outline-success",
                                      text: "Download",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadHistoryAsText(
                                              _vm.selectedHistory
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "bi bi-file-earmark-text",
                                        }),
                                        _vm._v(
                                          " Download as TXT\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "p-0 text-decoration-none",
                                    attrs: { variant: "link" },
                                    on: {
                                      click: function ($event) {
                                        _vm.selectedHistory = null
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "bi bi-arrow-left",
                                    }),
                                    _vm._v(" Back\n                "),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "history-detail p-3 border rounded",
                            staticStyle: { "white-space": "pre-wrap" },
                          },
                          [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.selectedHistory.result) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _c(
                        "div",
                        { staticClass: "history-list" },
                        _vm._l(_vm.history, function (item) {
                          return _c(
                            "div",
                            {
                              key: item.id,
                              staticClass:
                                "history-item p-3 mb-3 border rounded",
                              on: {
                                click: function ($event) {
                                  return _vm.openHistory(item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-start",
                                },
                                [
                                  _c("div", { staticClass: "flex-grow-1" }, [
                                    _c(
                                      "strong",
                                      { staticClass: "d-block mb-1" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDate(item.created_at)
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "mb-0 text-muted history-text",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.truncateText(item.result, 50)
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "delete-btn ml-3",
                                      attrs: { size: "sm", variant: "danger" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.confirmDeleteHistory(
                                            item.id
                                          )
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "bi bi-trash" })]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }